import { render, staticRenderFns } from "./HeadingDropdown.vue?vue&type=template&id=316569f8&scoped=true"
import script from "./HeadingDropdown.vue?vue&type=script&lang=js"
export * from "./HeadingDropdown.vue?vue&type=script&lang=js"
import style0 from "./HeadingDropdown.vue?vue&type=style&index=0&id=316569f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "316569f8",
  null
  
)

export default component.exports